import { SocialNetworkPrivacy } from '../../enums/social-network/social-network-privacy.enum';
import { SocialNetworkStatus } from '../../enums/social-network/social-network-status.enum';
import { SocialNetworkThreadOwnerType } from '../../enums/social-network/social-network-thread-owner-type.enum';
import { SocialNetworkInstanceImage } from './social-network-instance-image';
import { SocialNetworkReference } from './social-network-reference';

export class SocialNetworkInstance {
  public appId?: string;
  public description?: string;
  public name?: string;
  public privacy?: SocialNetworkPrivacy;
  public status?: SocialNetworkStatus;
  public token?: string;
  public slug?: string;
  public reference?: SocialNetworkReference;
  public images?: SocialNetworkInstanceImage[];
  public ownerType?: SocialNetworkThreadOwnerType;
  public ownerId?: string;
  public specialtyName?: string;
}
